import { useContext } from "react";
import {
  deleteRecurringTransaction,
  getAllRecurringTransactions,
  toggleRecurringPaymentStatus,
} from "../../services/transactionService";
import { AuthContext } from "../Auth/AuthContext";
import { useGroupContext } from "../Groups/useGroupContext";
import RecurringPaymentsTable from "./RecurringPaymentsTable";

const RecurringPayment = () => {
  const { getContextParams } = useGroupContext();
  const { userCurrency } = useContext(AuthContext);

  // Fetch function for recurring payments
  const fetchRecurringPayments = async () => {
    return await getAllRecurringTransactions(getContextParams());
  };

  // Delete function
  const deletePayment = async (id) => {
    return await deleteRecurringTransaction(id, getContextParams());
  };

  // Pause function
  const pausePayment = async (id) => {
    return await toggleRecurringPaymentStatus(id, "pause", getContextParams());
  };

  // Resume function
  const resumePayment = async (id) => {
    return await toggleRecurringPaymentStatus(id, "resume", getContextParams());
  };

  return (
    <RecurringPaymentsTable
      title="Your Recurring Payments"
      fetchFunction={fetchRecurringPayments}
      deleteFunction={deletePayment}
      pauseFunction={pausePayment}
      resumeFunction={resumePayment}
      editPath="/edit-payment"
      addPath="/add-transaction?type=EXPENSE&recurring=true"
    />
  );
};

export default RecurringPayment;
